export default "__VITE_ASSET__65f7866c__"